export const getModalClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 min-h-[65svh] h-[85svh] -translate-x-1/2 -translate-y-2/4 transform min-w-[calc(100%_-_1.5rem)] md:min-w-[90%] md:mx-auto'
}

export const getDetailsModalClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 max-h-[90%] -translate-x-1/2 -translate-y-2/4 transform min-w-[calc(100%_-_1.5rem)] md:min-w-[90%] mx-auto overflow-y-auto'
}

export const getDetailsModalOverflowVisibleClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 max-h-[90%] -translate-x-1/2 -translate-y-2/4 transform min-w-[calc(100%_-_1.5rem)] md:min-w-[90%] mx-auto overflow-visible'
}

export const getSmallModalClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 min-h-content max-h-[85svh] -translate-x-1/2 -translate-y-1/2 transform min-w-[calc(100%_-_1.5rem)] lg:min-w-[40%] lg:mx-auto overflow-y-auto'
}

export const getSmallModalOverflowVisibleClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 min-h-content max-h-[85svh] -translate-x-1/2 -translate-y-1/2 transform min-w-[calc(100%_-_1.5rem)] lg:min-w-[40%] lg:mx-auto overflow-visible'
}

export const getFilterModalClassNames = () => {
    return 'fixed left-0 top-0 z-20 h-screen w-full max-w-[400px] bg-background-base pt-6 pb-20 px-4'
}

export const getStepperModalClassNames = () => {
    return 'fixed left-1/2 top-1/2 z-10 min-w-[calc(100%_-_1.5rem)] lg:min-w-[90%] mx-auto h-[85svh] -translate-x-2/4 -translate-y-2/4 transform'
}

export const getModalContentClassNames = () => {
    return 'h-[65svh] lg:h-[70svh] 2xl:h-[70svh]'
}
export const getSmallerModalClassNames = () => {
    return 'fixed left-2/4 top-1/2 z-10  max-w-[600px] max-h-full'
}
export const getStepperFooterClassNames = () => {
    return 'flex flex-row justify-end absolute bottom-4 right-0 w-full p-4 bg-background-base gap-2'
}
export const getPermissionModalClassNames = () => {
    return 'z-60 max-w-[600px] sm:max-h-screen'
}

/**
 * rootClasses for every SnackBar. Position belongs to SnackBarProvider's
 * fixed Toast.Viewport (bottom on mobile, top from sm) — a toast that sets
 * its own `absolute left-1/2 …` leaves the viewport with no in-flow content,
 * so it collapses to zero width and the message wraps into a thin column.
 * Width is clamped to the screen; first-child:flex-1 keeps the text centred
 * between the icon and the close button.
 */
export const getSnackBarClassNames = () => {
    return 'text-sm min-w-[min(360px,calc(100vw-2rem))] max-w-[min(640px,calc(100vw-2rem))] [&>*:first-child]:flex-1 [&_span]:whitespace-normal [&_span]:break-words'
}
